import React, { useEffect, useState, useRef } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import PaginationTable from '../../pagination/Pagination4';

 

const MonthC = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

const Nom_cards_data = async (params) => {
    const response = await fetch(`${process.env.REACT_APP_URL_SIDE}/sdms/Nominee_Cards_List`, {

        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(params),
    });
    if (!response.ok) {
        throw new Error('Failed to fetch data');
    }
    return response.json();
};

const Nominee_Cards_List = ({ dist_code, dist_name, afso_code, afso_name_en,fps_id, heading }) => {
    const [reportData, setReportData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [tabHeading, setTabHeading] = useState(heading);
    
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(50);
    const [searchQuery, setSearchQuery] = useState(''); 
   const detailsLoad = useRef(null);

    useEffect(() => {
        const getData = async () => {
            try {
                const response_data = await Nom_cards_data({ dist_code, afso_code ,fps_id });

                if (Array.isArray(response_data.data)) {
                    setReportData(response_data.data);
                    setTabHeading(response_data.heading)
                } else {
                    setReportData([]);
                }
            } catch (error) {
                setError(error);
            } finally {
                setLoading(false);
            }
        };

        getData();
    }, [ dist_code, afso_code,fps_id]);
    useEffect(() => {
        if (!loading && !error && reportData.length > 0 && detailsLoad.current) {
            // detailsLoad.current.scrollIntoView({ behavior: 'smooth' , block: 'end'});
            const elementPosition = detailsLoad.current.offsetTop;
            window.scrollTo({
                top: elementPosition,
                behavior: 'smooth'
            });
        }
    }, [loading, error, reportData]);

    if (loading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <Box sx={{ display: 'flex' }}>
                    <CircularProgress />
                </Box>
            </div>
        );
    }

    if (error) {
        return <div className="mainhead" align="center">Internal error</div>;
    }

    if (reportData.length === 0) {
        return <div className="mainhead" align="center">No data found</div>;
    }
    
    return (
        <>
            <table align="center" width="60%" border={1} ref={detailsLoad}>
                <thead>
                    <tr className="tableheader">
                        <th colSpan={19}> {tabHeading} 
                            <font style={{ color: 'orange' }} > </font>
                        </th>
                    </tr>
                    <tr className="tableheader">
                        <th>Sl.No</th>
                        <th>RC No</th>
                        <th>Nominee Name</th>
                        <th>Nominee Mobile</th>
                        <th>Mapped<br />Date </th>
                    </tr>
                </thead>
                <tbody>
                    {reportData.map((item, index) => (
                        <tr key={item.rc_id}>
                            <td style={{ textAlign: 'center' }}>{index + 1}</td>
                            <td style={{ textAlign: 'left' }}>{item.rc_id} </td>
                            <td style={{ textAlign: 'left' }}>{item.nom_name}</td>
                            <td style={{ textAlign: 'left' }}>{item.nom_mobile}</td>
                            <td style={{ textAlign: 'left' }}>{item.date}</td>
                        </tr>
                    ))}
                </tbody>
                
            </table>
            <br /><br />
            <br /><br />

        </>
    );
};

export default Nominee_Cards_List;
